import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import { PublicLayout } from "@/components/layout/PublicLayout";
import { MemberLayout } from "@/components/layout/MemberLayout";
import { AdminLayout } from "@/components/layout/AdminLayout";

import Home from "@/pages/public/Home";
import Tentang from "@/pages/public/Tentang";
import Kepimpinan from "@/pages/public/Kepimpinan";
import Jurulatih from "@/pages/public/Jurulatih";
import Keahlian from "@/pages/public/Keahlian";
import Direktori from "@/pages/public/Direktori";
import Semak from "@/pages/public/Semak";
import TuntutKeahlian from "@/pages/public/TuntutKeahlian";
import Program from "@/pages/public/Program";
import Berita from "@/pages/public/Berita";
import Hubungi from "@/pages/public/Hubungi";
import Login from "@/pages/public/Login";
import MemberPublicProfile from "@/pages/public/MemberPublicProfile";
import Daftar from "@/pages/daftar/Daftar";
import Kursus from "@/pages/public/Kursus";

import Dashboard from "@/pages/member/Dashboard";
import KadAhli from "@/pages/member/KadAhli";
import Profil from "@/pages/member/Profil";
import StatusKeahlian from "@/pages/member/StatusKeahlian";
import Dokumen from "@/pages/member/Dokumen";
import Pengumuman from "@/pages/member/Pengumuman";
import ProgramMember from "@/pages/member/ProgramMember";
import JawatankuasaMember from "@/pages/member/JawatankuasaMember";
import Tetapan from "@/pages/member/Tetapan";
import MenuMobile from "@/pages/member/MenuMobile";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import Permohonan from "@/pages/admin/Permohonan";
import PermohonanDetail from "@/pages/admin/PermohonanDetail";
import Ahli from "@/pages/admin/Ahli";
import AhliDetail from "@/pages/admin/AhliDetail";
import KategoriKeahlian from "@/pages/admin/KategoriKeahlian";
import Jawatankuasa from "@/pages/admin/Jawatankuasa";
import JurulatihAdmin from "@/pages/admin/Jurulatih";
import PengumumanAdmin from "@/pages/admin/PengumumanAdmin";
import KursusLeads from "@/pages/admin/KursusLeads";
import PenggunaStaf from "@/pages/admin/PenggunaStaf";
import DokumenAdmin from "@/pages/admin/DokumenAdmin";
import AuditLog from "@/pages/admin/AuditLog";
import TetapanAdmin from "@/pages/admin/TetapanAdmin";

const STAFF_ROLES = ["super_admin", "secretariat", "president", "treasurer", "committee", "verifier"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tentang" element={<Tentang />} />
              <Route path="/kepimpinan" element={<Kepimpinan />} />
              <Route path="/jurulatih" element={<Jurulatih />} />
              <Route path="/keahlian" element={<Keahlian />} />
              <Route path="/direktori" element={<Direktori />} />
              <Route path="/semak" element={<Semak />} />
              <Route path="/semak/:token" element={<Semak />} />
              <Route path="/tuntut-keahlian" element={<TuntutKeahlian />} />
              <Route path="/program" element={<Program />} />
              <Route path="/berita" element={<Berita />} />
              <Route path="/hubungi" element={<Hubungi />} />
              <Route path="/member/:memberNumber" element={<MemberPublicProfile />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/daftar" element={<Daftar />} />
            <Route path="/kursus" element={<Kursus />} />

            <Route path="/app" element={<ProtectedRoute roles={["member"]}><MemberLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="kad" element={<KadAhli />} />
              <Route path="profil" element={<Profil />} />
              <Route path="status" element={<StatusKeahlian />} />
              <Route path="dokumen" element={<Dokumen />} />
              <Route path="pengumuman" element={<Pengumuman />} />
              <Route path="program" element={<ProgramMember />} />
              <Route path="jawatankuasa" element={<JawatankuasaMember />} />
              <Route path="tetapan" element={<Tetapan />} />
              <Route path="menu" element={<MenuMobile />} />
            </Route>

            <Route path="/admin" element={<ProtectedRoute roles={STAFF_ROLES}><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="permohonan" element={<Permohonan />} />
              <Route path="permohonan/:id" element={<PermohonanDetail />} />
              <Route path="ahli" element={<Ahli />} />
              <Route path="ahli/:id" element={<AhliDetail />} />
              <Route path="kategori" element={<KategoriKeahlian />} />
              <Route path="jawatankuasa" element={<Jawatankuasa />} />
              <Route path="jurulatih" element={<JurulatihAdmin />} />
              <Route path="pengumuman" element={<PengumumanAdmin />} />
              <Route path="kursus-leads" element={<KursusLeads />} />
              <Route path="pengguna-staf" element={<PenggunaStaf />} />
              <Route path="dokumen" element={<DokumenAdmin />} />
              <Route path="audit-log" element={<AuditLog />} />
              <Route path="tetapan" element={<TetapanAdmin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
